// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__1E8dh","lastUpdated":"TermsOfService_lastUpdated__16NPn"};